import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Input, Modal, Form } from 'antd';
import { isEmpty, notificationHelper } from '../../utils/helper';
import './style.scss';
import UserAvatar from '../UserAvatar';
import UserProfile from '../UserProfile';
const {
  Item
} = Form;
class UserNameComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleMandatoryFields = (e, type) => {
      this.setState({
        [type]: e.target.value
      });
    };
    this.handleOk = () => {
      const {
        firstName,
        lastName,
        phone
      } = this.state;
      const {
        updateUserDetailsData,
        apiBaseUrl
      } = this.props;
      const payload = {
        firstName,
        lastName,
        phone
      };
      updateUserDetailsData(payload, apiBaseUrl).then(() => {
        this.setState({
          visible: false
        });
      });
    };
    this.handleOpenDrawer = () => {
      const {
        showDrawer
      } = this.state;
      this.setState({
        showDrawer: !showDrawer
      });
    };
    this.renderUserProfile = () => {
      const {
        userDetails
      } = this.props;
      const {
        firstName,
        lastName,
        profile_pic
      } = userDetails;
      const {
        isUserDataLoaded
      } = this.state;
      return /*#__PURE__*/React.createElement(React.Fragment, null, isUserDataLoaded && /*#__PURE__*/React.createElement("div", {
        className: "user-profile-container",
        onClick: this.handleOpenDrawer,
        role: "button",
        tabIndex: 0
      }, !isEmpty(userDetails) && /*#__PURE__*/React.createElement(UserAvatar, {
        userName: {
          firstName,
          lastName
        },
        userProfilePicture: profile_pic
      }), /*#__PURE__*/React.createElement("div", {
        className: "user-profile-name"
      }, /*#__PURE__*/React.createElement("span", {
        className: "user-name"
      }, " ", firstName, " ", lastName, " "))));
    };
    this.renderSettingModal = () => {
      const {
        firstName,
        lastName,
        phone,
        visible
      } = this.state;
      const {
        userDetails
      } = this.props;
      return visible && /*#__PURE__*/React.createElement(Modal, {
        title: __('User Information'),
        visible: visible,
        onOk: this.handleOk,
        closable: false,
        okText: __('Save'),
        centered: true,
        className: "setting-confirmation-modal",
        okButtonProps: {
          disabled: !(lastName && firstName && phone)
        },
        cancelButtonProps: {
          style: {
            display: 'none'
          }
        },
        id: "modal-setting"
      }, /*#__PURE__*/React.createElement("p", null, __('Mandatory detail is missing in your user profile. Please fill the missing field')), /*#__PURE__*/React.createElement(Form, {
        className: "user-form"
      }, !userDetails.firstName ? /*#__PURE__*/React.createElement(Item, {
        label: __("First Name"),
        required: true
      }, /*#__PURE__*/React.createElement(Input, {
        id: "firstName",
        value: firstName,
        onChange: e => this.handleMandatoryFields(e, 'firstName')
      })) : '', !userDetails.lastName ? /*#__PURE__*/React.createElement(Item, {
        label: __("Last Name"),
        required: true
      }, /*#__PURE__*/React.createElement(Input, {
        id: "lastName",
        value: lastName,
        onChange: e => this.handleMandatoryFields(e, 'lastName')
      })) : '', !userDetails.phone ? /*#__PURE__*/React.createElement(Item, {
        label: __("Phone #"),
        required: true
      }, /*#__PURE__*/React.createElement(Input, {
        className: "user-phone-number",
        id: "phone",
        type: "number",
        value: phone,
        onChange: e => this.handleMandatoryFields(e, 'phone')
      })) : ''));
    };
    this.state = {
      visible: false,
      firstName: '',
      lastName: '',
      phone: '',
      showDrawer: false,
      isUserDataLoaded: false,
      userProfilePicture: ''
    };
  }
  componentDidMount() {
    const {
      getUserDetails,
      apiBaseUrl
    } = this.props;
    getUserDetails(apiBaseUrl);
  }
  componentDidUpdate(preProps, preState) {
    const {
      userDetails
    } = this.props;
    if (preProps.userDetails !== userDetails) {
      this.setState({
        isUserDataLoaded: true,
        userProfilePicture: userDetails.profile_pic
      });
    }
  }
  static getDerivedStateFromProps(props, state) {
    const {
      userDetails,
      isFetchApiSuccess,
      isPartnerSite
    } = props;
    if (isFetchApiSuccess && userDetails && Object.keys(userDetails).length === 0) {
      notificationHelper('warn', __('Unknown User'), __('Unknown user session. Redirecting to Sign in page.'));
      return state;
    }
    if (userDetails && isFetchApiSuccess) {
      const {
        firstName,
        lastName,
        phone
      } = userDetails;
      const newState = {};
      if (!firstName || !lastName || !phone) {
        newState.visible = !isPartnerSite;
      } else {
        newState.visible = false;
      }
      const {
        resetUserDetailAPIEvent
      } = props;
      resetUserDetailAPIEvent();
      return _objectSpread(_objectSpread({}, newState), userDetails);
    }
    return state;
  }
  render() {
    const {
      userDetails: {
        firstName,
        lastName
      },
      apiBaseUrl,
      userDetails,
      updateUserDetailsData
    } = this.props;
    const {
      showDrawer,
      isUserDataLoaded
    } = this.state;
    return /*#__PURE__*/React.createElement(Fragment, null, isUserDataLoaded && this.renderUserProfile(), this.renderSettingModal(), showDrawer && /*#__PURE__*/React.createElement(UserProfile, {
      userData: userDetails,
      apiBaseUrl: apiBaseUrl,
      handleOpenDrawer: this.handleOpenDrawer,
      updateUserDetailsData: updateUserDetailsData,
      firstName: firstName,
      lastName: lastName
    }));
  }
}
UserNameComponent.propTypes = {
  apiBaseUrl: PropTypes.string.isRequired,
  getUserDetails: PropTypes.func.isRequired,
  updateUserDetailsData: PropTypes.func.isRequired,
  userDetails: PropTypes.object.isRequired
};
export default UserNameComponent;